module.exports = __webpack_public_path__ + "static/media/whyLokah.32298b97.png";